import Api from '../Api';

class RegionApi extends Api {
  constructor() {
    super('regions', 'regions');
  }
}
const regionApi = new RegionApi();
export default regionApi;
